import React from 'react';
import PropTypes from 'prop-types';
import CurrentRoleStore from '../../stores/CurrentRoleStore';
import DataService from '../../lib/DataService';
import SharedTools from '../../lib/SharedTools';
import { Select, Modal, message } from 'antd';

const Option = Select.Option;

export default class ArchiveProcessStudentsDetailPage extends React.Component {
  static propTypes = {
  };

  constructor(props) {
    super(props);
    let currentSemester = SharedTools.getCurrentSemester();
    // set state
    this.state = {
      currentRole: CurrentRoleStore.getCurrentRole(),
      semester: props.location.query.semester ? props.location.query.semester : currentSemester,
      statisticTemplateId: props.location.query.id ? props.location.query.id : 0,
      classId: this.props.params.classId,
      templates: []
    };
  }

  componentDidMount() {
    this.getStudents()
  }

  getStudents() {
    DataService.getStudents(this.state.classId).then(res => {
      let students = res.map(s => {
        return {
          full_name: s.full_name,
          id: s.id,
          complete_status: false
        }
      })
      this.getStatisticTemplateClassStatus(students)
    }).catch((error) => {
      message.error('获取数据失败');
    })
  }
  

  getStatisticTemplateClassStatus(students) {
    let data = {
      class_record_id: this.state.classId,
      statistic_template_id: this.state.statisticTemplateId
    }
    DataService.getStatisticTemplateClassStatus(data).then(res => {
      res.map(item => {
        let arr = JSON.parse(JSON.stringify(students));
        item.completes.forEach(s => {
          let student = arr.find(student => student.id == s.id)
          if (student) {
            student.complete_status = true
          }
        })
        item.students = arr
      })
      this.setState({
        templates: res
      })
    }).catch((error) => {
      message.error('获取数据失败');
    })
  }

  render() {
    let { templates } = this.state;
    return (
      <div className="archive-process-students-detail-page">
        {templates.map(template => <div className="container" key={template.id}>
          <div className="container-header">
            <div className="header-title">{template.page_title ? template.page_title : template.template.title}</div>
            <div>已完成{template.complete_count}/{template.student_count}人</div>
          </div>
          <div className="student-list">
            {template.students.map(s => <div className="student-detail" key={s.id}>
              <div>{s.full_name}</div>
              {s.complete_status ? <div className="status">已完成</div> : <div className="status unfinished">未完成</div>}
            </div>)}
          </div>
        </div>)}

      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/process/ArchiveProcessStudentsDetailPage.jsx